import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { cmsApiRequest } from "../../Lib/Utils/ApiRequest";
import { getLocaleFromCookie } from "../../Lib/Utils/getLocaleFromCookie";
import { ICmsTravelPassOfferResponse } from "../../Orchestrator/Types/Interface/ICMSOffers";

export const getCmsTravelPassOffers = async () => {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.getCmsTravelPassOffersAPI;

  const params = new URLSearchParams();
  const locale = await getLocaleFromCookie();

  params.append("locale", locale);
  params.append("populate", "origin");
  params.append("populate", "destination");
  params.append("populate", "image");

  let endpointWithParams = `${endpoint}?${params.toString()}`;
  return await cmsApiRequest<ICmsTravelPassOfferResponse>(
    endpointWithParams,
    "GET"
  );
}
